export default "__VITE_ASSET__GhUC_U36__"